module.exports = __webpack_public_path__ + "assets/img/oral_bottle_icon.8f3b30bc.svg";